import React from "react";
import _ from "lodash";

import { Modal } from "@toddle-edu/ds-web";
import useI18n from "Hooks/UseI18n";
import classNames from "classnames";

import classes from "./PollResultsModal.scss";
import PollGraph from "../PollGraph";
import PollUsersList from "./PollUsersList";

const styles = {
  modalBody: {
    padding: "0px",
    overflow: "hidden",
  },
};

const PollResultsModal = props => {
  const { onCloseModal, interaction } = props;

  const question = _.get(interaction, "question", "");

  const pollId = _.get(interaction, "id", "");

  const { t } = useI18n(["common"]);

  return (
    <Modal
      dsVersion={"2.0"}
      height="720px"
      hasOverlay
      width="480px"
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      onClose={onCloseModal}
      isOpen
    >
      <Modal.Header
        title={t("common:poll_results")}
        isClosable={true}
        hasSeparator
      />
      <Modal.Body isScrollable={false} style={styles.modalBody}>
        <div className={classes.pollModalBody}>
          <div className={classes.pollDetails}>
            <div className="text-label">{question}</div>
            <PollGraph interaction={interaction} isEditable={false} isCreator />
          </div>
          <div className={classes.pollUsers}>
            <div className={classNames(classes.pollUsersHeader, "text-label")}>
              {t("common:votes")}
            </div>
            <div className={classes.pollUsersList}>
              <PollUsersList pollId={pollId} />
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PollResultsModal;
